// convocationSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentYear: '',
  currentMonth: '',
  currentDate: '',
  currentYearConvocationId: '',
  slides: [],
  animateIn: false,
};

const convocationSlice = createSlice({
  name: 'convocation',
  initialState,
  reducers: {
    setCurrentYear(state, action) {
      state.currentYear = action.payload;
    },
    setCurrentMonth(state, action) {
      state.currentMonth = action.payload;
    },
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
    setCurrentYearConvocationId(state, action) {
      state.currentYearConvocationId = action.payload;
    },
    // setSlides(state, action) {
    //   state.slides = action.payload;
    // },
    setAnimateIn(state, action) {
      state.animateIn = action.payload;
    },
  },
});

export const { setCurrentYear, setCurrentYearConvocationId, setSlides, setAnimateIn,setCurrentDate,setCurrentMonth } = convocationSlice.actions;

export default convocationSlice.reducer;
 